// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__33HMW","label":"SetPasswdForm_label__1DQTg"};